import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Cookies() {
  const { t } = useTranslation();
  const sections = t('cookies.sections', { returnObjects: true }) || [];
  const openPrefs = (e) => {
    e.preventDefault();
    if (window.__openCookiePrefs) window.__openCookiePrefs();
  };
  return (
    <div className="legal-page">
      <div className="container">
        <div className="header-block">
          <h1>{t('cookies.title')}</h1>
          <span className="updated">{t('cookies.updated')}</span>
        </div>
        <div className="legal-body">
          {Array.isArray(sections) && sections.map((s, i) => (
            <div key={i}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </div>
          ))}
          <div style={{ marginTop: 40 }}>
            <a href="#" onClick={openPrefs} className="btn-secondary" data-testid="open-cookie-prefs">
              {t('cookie.manage')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
